import {
  $Resource,
  $HttpOk,
  $HttpUnauthorized,
  $HttpUnprocessableEntity,
  $HttpForbidden,
  $HttpNotFound,
  $HttpHeaders,
} from '@flowio/api-sdk';

export type InternalPaymentRequestsGetResponse =
  | $HttpOk<io.flow.internal.v0.models.InternalPaymentRequest>
  | $HttpUnauthorized<undefined>
  | $HttpForbidden<io.flow.v0.models.GenericError>
  | $HttpNotFound<undefined>;
export type InternalPaymentRequestsPostPaymentAndMethodAndActionAndCancellationResponse =
  | $HttpOk<io.flow.internal.v0.models.InternalPaymentRequest>
  | $HttpUnauthorized<undefined>
  | $HttpNotFound<undefined>
  | $HttpUnprocessableEntity<io.flow.error.v0.models.GenericError>;
export type InternalPaymentRequestsPostPaymentAndMethodAndDataResponse =
  | $HttpOk<io.flow.internal.v0.models.InternalPaymentRequest>
  | $HttpUnauthorized<undefined>
  | $HttpNotFound<undefined>
  | $HttpUnprocessableEntity<io.flow.error.v0.models.GenericError>;

export interface InternalPaymentRequestsGetParameters {
  headers?: $HttpHeaders;
  /* Refers to your organization's account identifier */
  organization: string;
  /* Filter by one or more IDs of this resource */
  id: string;
}

export interface InternalPaymentRequestsPostPaymentAndMethodAndActionAndCancellationParameters {
  body: io.flow.payment.gateway.v0.models.PaymentMethodActionCancellation;
  headers?: $HttpHeaders;
  /* Refers to your organization's account identifier */
  organization: string;
  /* Filter by one or more IDs of this resource */
  id: string;
}

export interface InternalPaymentRequestsPostPaymentAndMethodAndDataParameters {
  body: io.flow.payment.gateway.v0.unions.PaymentMethodData;
  headers?: $HttpHeaders;
  /* Refers to your organization's account identifier */
  organization: string;
  /* Filter by one or more IDs of this resource */
  id: string;
}

export default class InternalPaymentRequestsResource extends $Resource {
  public get(
    params: InternalPaymentRequestsGetParameters,
  ): Promise<InternalPaymentRequestsGetResponse> {
    return this.client.request({
      endpoint: `/${encodeURIComponent(params.organization)}/payment/requests/${encodeURIComponent(params.id)}/internal`,
      headers: params.headers,
      method: 'GET',
    });
  }

  /* Update the payment method data to progress the payment through relevant actions */
  public postPaymentAndMethodAndData(
    params: InternalPaymentRequestsPostPaymentAndMethodAndDataParameters,
  ): Promise<InternalPaymentRequestsPostPaymentAndMethodAndDataResponse> {
    return this.client.request({
      body: params.body,
      endpoint: `/${encodeURIComponent(params.organization)}/payment/requests/${encodeURIComponent(params.id)}/internal/payment/method/data`,
      headers: params.headers,
      method: 'POST',
    });
  }

  /* Cancel the active action & authorization on the payment request */
  public postPaymentAndMethodAndActionAndCancellation(
    params: InternalPaymentRequestsPostPaymentAndMethodAndActionAndCancellationParameters,
  ): Promise<InternalPaymentRequestsPostPaymentAndMethodAndActionAndCancellationResponse> {
    return this.client.request({
      body: params.body,
      endpoint: `/${encodeURIComponent(params.organization)}/payment/requests/${encodeURIComponent(params.id)}/internal/payment/method/action/cancellation`,
      headers: params.headers,
      method: 'POST',
    });
  }
}
